import { default as NextImage } from "next/image";
import type React from "react";

import { getStrapiMedia, isSvgUrl } from "@/app/[lang]/utils/api-helpers";

import type { ImageProps } from "./interface"

type ImageComponentProps = {
    data: ImageProps,
    fill?: boolean,
    hidden?: boolean,
    sizes?: string,
    alt: string,
    className?: string,
    style?: React.CSSProperties
}

export const Image:React.FC<ImageComponentProps> = (props) => {
    const { data, fill, alt, hidden } = props;
    const src = getStrapiMedia(data.attributes.url)

    if ( !src || !!hidden) {
        return null
    }

    const extraProps = fill
        ? { fill: true, sizes: props?.sizes ?? '100vw' }
        : {
            width: data.attributes.width,
            height: data.attributes.height
        }
    
    return (
        <NextImage
            src={ src }
            alt={ data.attributes.alternativeText ?? alt }
            loading="lazy"
            decoding="async"
            className={props.className}
            style={props.style}
            unoptimized={isSvgUrl(src)}
            { ...extraProps }
        />
    )
}
